import { Typography } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { HtmlReactParser, translate } from "@kaltura/mediaspace-shared-utils";

interface Props {
    systemName?: string;
}

const Content = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: theme.spacing(2.5),
}));

const Message = styled(Typography)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        "& span": {
            fontWeight: theme.kaltura.typography.fontWeightBold,
        },
    },
]);

/**
 *  Restream Modal delete content
 */
const RestreamModalDelete = (props: Props) => {
    const { systemName = "" } = props;

    return (
        <Content>
            <Message variant={"body1"}>
                {HtmlReactParser(
                    translate("Are you sure you want to delete %1 destination?", [`<span>${systemName}</span>`])
                )}
            </Message>
            <Typography variant={"body1"}>{translate("This action cannot be undone")}</Typography>
        </Content>
    );
};

export default RestreamModalDelete;
